import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import Tooltip from './Tooltip/Tooltip'

interface DateTooltipProps {
  date: string
  tooltip: string | null
}

export default class DateTooltip extends Component<DateTooltipProps> {
  get date () {
    return dateUtil.format(this.props.date)
  }

  get tooltip () {
    const { tooltip } = this.props
    return tooltip &&
      <Tooltip text={tooltip}>
        {this.date}
      </Tooltip>
  }

  render () {
    const { tooltip } = this.props
    return tooltip
      ? this.tooltip
      : this.date
  }
}
